export default "__VITE_ASSET__D1fp2dvs__"